import {connect} from 'react-redux';
import SideBar from './SideBar';

const mapStateToProps = ({
                           user: {
                             user: {attributes}
                           }
                         }) => ({
  user: attributes,
});

export default connect(
  mapStateToProps,
  null
)(SideBar);
